import React from "react";
import LinearProgress from '@mui/material/LinearProgress';
export default function ProgressBar() {
    return (
        <div
            style={{
                position: 'fixed',
                top: '50%',
                width: '100%',
                height: '100%'
            }}>
            <div style={{ width: '50%', position: 'relative', left: '25%' }}>
                <LinearProgress color="primary" />
            </div>
        </div>
    );
}